export const ptKeys = {
  all: ["clubs", "pt"] as const,
  club: (clubId: number) => ["clubs", clubId, "pt"] as const,
  trainers: (clubId: number) => [...ptKeys.club(clubId), "trainers"] as const,
  slots: (clubId: number, trainerId: number, date: string) =>
    [...ptKeys.club(clubId), "slots", trainerId, date] as const,
  trainerSlots: (clubId: number, trainerId: number, date: string) =>
    [...ptKeys.club(clubId), "trainer-slots", trainerId, date] as const,
  appointments: (clubId: number) =>
    [...ptKeys.club(clubId), "appointments"] as const,
  mine: (clubId: number) => [...ptKeys.appointments(clubId), "mine"] as const,
  availability: (clubId: number) =>
    [...ptKeys.club(clubId), "trainer", "availability"] as const,
  exceptions: (clubId: number, from?: string, to?: string) =>
    [
      ...ptKeys.club(clubId),
      "trainer",
      "availability",
      "exceptions",
      from,
      to,
    ] as const,
  requests: (clubId: number) =>
    [...ptKeys.club(clubId), "trainer", "requests"] as const,
  schedule: (clubId: number, from?: string, to?: string) =>
    [...ptKeys.club(clubId), "trainer", "schedule", from, to] as const,
  members: (clubId: number, query: string) =>
    [...ptKeys.club(clubId), "trainer", "members", query] as const,
};
